document.addEventListener("DOMContentLoaded", () => {
  const isMobile = () => window.matchMedia("(max-width: 768px)").matches;

  // The checkbox/label toggle (header.twig, _header.scss) needs no JS — this is enhancement only.
  const navToggle = document.getElementById(
    "nav-toggle",
  ) as HTMLInputElement | null;
  const navPrimary = document.getElementById(
    "nav-primary",
  ) as HTMLElement | null;

  if (navToggle && navPrimary) {
    const closeNav = () => {
      navToggle.checked = false;
      document.body.classList.remove("nav-is-open");
    };

    navToggle.addEventListener("change", () => {
      document.body.classList.toggle("nav-is-open", navToggle.checked);
      if (navToggle.checked) {
        navPrimary.querySelector<HTMLElement>(".nav-menu__link")?.focus();
      }
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && navToggle.checked) {
        closeNav();
        navToggle.focus();
      }
    });

    navPrimary.addEventListener("click", (e) => {
      if (e.target === navPrimary) closeNav();
    });

    window.addEventListener("resize", () => {
      if (!isMobile() && navToggle.checked) {
        closeNav();
      }
    });
  }
});
